import { startOfDay } from "date-fns";

import { getRefreshBucketStart, HaNContext } from "@lib/logic";
import { type AreaWithSensorInfo, getNodeInformationPerAreaByBuildingId, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { HaNMapPreview } from "../../HaNMapPreview";

// The area on its floor, marked with how many of its places are free today
export const AreaMapPreview = ({ area }: { area: AreaWithSensorInfo }) => {
  const { bucket } = useRequiredContext(HaNContext);
  const day = startOfDay(getRefreshBucketStart(bucket)).toISOString();
  const bookingState = useAppSelector(state => {
    return getNodeInformationPerAreaByBuildingId(state, day, area.buildingId)?.[area.id];
  });

  const available = bookingState
    ? bookingState.capacity - bookingState.occupation
    : area.capacity || area.adHocCapacity;

  return (
    <HaNMapPreview
      buildingId={area.buildingId}
      floorId={area.floorId}
      nodeId={area.id}
      markerData={[{ type: "area", nodeId: area.id, available, connections: [] }]}
    />
  );
};
